import { useFormik } from 'formik';
import { Flex, Stack } from "@chakra-ui/react";
import CustomInput from "../../form-components/CustomInput";
import SubmitButton from "../../custom/SubmitButton";
import { UseApi } from '../../../libraries/UseApi';
import { UserInfoContext } from '../../../provider/UserInfoProvider';
import * as Yup from 'yup';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

const AddBranchForm = ({ branch = {}, isEdit = false }) => {
    const { postApi, patchApi } = UseApi();
    const { token } = useContext(UserInfoContext);
    const navigate = useNavigate();
    const formik = useFormik({
        initialValues: {
            branch: branch?.branch
        },
        validationSchema: Yup.object({
            branch: Yup.string().required('支社を必修'),
        }),
        onSubmit: (values) => {
            if (isEdit) {
                patchApi(
                    `${process.env.REACT_APP_API_URL}/branch/${branch?.id}`, values, { token: token },
                    (response) => {
                        // レスポンスチェック
                        if (response.isSuccess === false) {
                            // 入力内容を確認してください。
                            //alert(Message.Common.CONFIRM_INPUT);
                            return;
                        }
                        navigate('/branches');
                    }
                );
            } else {
                postApi(
                    `${process.env.REACT_APP_API_URL}/branch`, values, { token: token },
                    (response) => {
                        // レスポンスチェック
                        if (response.isSuccess === false) {
                            // 入力内容を確認してください。
                            //alert(Message.Common.CONFIRM_INPUT);
                            return;
                        }
                        navigate('/branches');
                    }
                );
            }
        }
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <Stack spacing={4} key={'addbranch'}>
                <CustomInput
                    formik={formik}
                    label={'支社'}
                    type={'text'}
                    name={'branch'}
                    id={'branch'}
                    placeholder={'支社を入力'}
                    required={true}
                />
                <Stack spacing={10}>
                    <Flex gap={2}>
                        <SubmitButton buttonText={isEdit ? '編集' : '登録'} />
                    </Flex>
                </Stack>
            </Stack>
        </form>
    );
}

export default AddBranchForm;